import React from "react";
import { Link } from "react-router-dom";

import { useNavigate } from 'react-router-dom';
import { getUser, logout } from '../../config/auth';
import '../../assets/css/Sidebar.css';
import Logo from "../../assets/img/hph-logo.png"


const Navbar = () => {
  // <nav className="navbar navbar-expand-lg navbar-dark bg-primary px-4 py-2">
  //   <Link className="navbar-brand" to="/receptionist">Receptionist Panel</Link>
  //   <div className="collapse navbar-collapse">
  //     <ul className="navbar-nav">
  //       <li className="nav-item"><Link className="nav-link" to="/receptionist">Dashboard</Link></li>
  //       <li className="nav-item"><Link className="nav-link" to="/receptionist/patients/new">Add Patient</Link></li>
  //       <li className="nav-item"><Link className="nav-link" to="/receptionist/appointments/new">Book Appointment</Link></li>
  //       <li className="nav-item"><Link className="nav-link" to="/receptionist/appointments">Appointments</Link></li>
  //     </ul>
  //   </div>
  // </nav>

const user = getUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };


  return (
  <>
  <div className="topbar-container d-flex justify-content-between align-items-center p-1 bg-light shadow-sm gap-3">
    <img src={Logo} alt="logo" className='h-15 w-20 ms-2' />
      <h4 className="m-0 text-center">Hospital Management</h4>

      <div className="d-flex align-items-center gap-3">
        <span>👤 {user?.fullName || 'User'}</span>
        <button onClick={handleLogout} className="btn btn-outline-danger btn-sm">
          Logout
        </button>
      </div>
    </div>
  </>
);
}

export default Navbar;